jQuery( document ).ready( function( $ ) {

    $( '.sidebar-title' ).click( () => {
        $( '.sidebar-title' ).toggleClass( 'active' );
        if( $( window ).width() < 768 ){
            $( '.sidebar-categories' ).slideToggle();
        }
    });

});